import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* getPerkPageConfigWatcherSaga() {
  yield takeLatest(types.GET_PERK_PAGE_CONFIG_REQUEST, workerSaga);
}

export function fetchData(entitySlug) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/client/${client}/entity/${entitySlug}/perkpageconfiguration/`;

  return axios.get(url)
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga(action) {
  try {
    const { entitySlug } = action;
    const response = yield call(fetchData, entitySlug);

    if (response && response.status === 200) {
      const { data } = response;

      yield put({ type: types.GET_PERK_PAGE_CONFIG_SUCCESS, data });

    } else {
      yield put({ type: types.GET_PERK_PAGE_CONFIG_FAILURE, error: 'Failed to fetch configuration.'});
    }
  } catch (error) {
    console.log(error)
    yield put({ type: types.GET_PERK_PAGE_CONFIG_FAILURE, error });
  }
}
